import React from "react";
import "./SpeedTimer.css";

const TOTAL = 15;
const RADIUS = 36;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

function getColor(t) {
  if (t > 10) return "#22c55e";
  if (t > 6)  return "#eab308";
  if (t > 3)  return "#f97316";
  return "#ef4444";
}

export default function SpeedTimer({ timeLeft }) {
  const fraction = Math.max(0, timeLeft) / TOTAL;
  const dashOffset = CIRCUMFERENCE * (1 - fraction);
  const color = getColor(timeLeft);
  const urgent = timeLeft <= 5;

  return (
    <div className={`speedTimer${urgent ? " speedTimerUrgent" : ""}`}>
      <svg width="88" height="88" viewBox="0 0 88 88">
        <circle
          cx="44" cy="44" r={RADIUS}
          fill="rgba(0,0,0,0.55)"
          stroke="rgba(255,255,255,0.07)"
          strokeWidth="7"
        />
        <circle
          cx="44" cy="44" r={RADIUS}
          fill="none"
          stroke={color}
          strokeWidth="7"
          strokeLinecap="round"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={dashOffset}
          transform="rotate(-90 44 44)"
          style={{ transition: "stroke-dashoffset 0.92s linear, stroke 0.3s" }}
        />
        <text x="44" y="38" textAnchor="middle" fill={color} fontSize="13" fontWeight="bold">⚡</text>
        <text x="44" y="59" textAnchor="middle" fill={color} fontSize="21" fontWeight="900"
          style={{ fontFamily: "monospace" }}>{timeLeft}</text>
      </svg>
    </div>
  );
}
